import "@/styles/public.css"; // tasks.md #29 -- public route-group CSS bundle
import { Button } from "@/components/ui/button";
import { Helmet } from "react-helmet";

// Catch-all 404 for every unknown SPA route (App.tsx <Route component={NotFound} />).
// Kept generic — no marketplace/directory language, per the knowledge-panel guardrails.
// One action only (home) — this page isn't a signup funnel, so no "Create your page" CTA.
// NOTE: the SPA serves this at HTTP 200 (soft-404); a true 404 status would need a
// server-side change and is out of scope for this visual pass. (Some paths — e.g. the
// retired /training/* marketplace URLs — get a real HTTP 410 server-side before the SPA
// ever renders this; see server/ssr/gonePage.ts.)
export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>Page not found | Training Booker</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <div className="bg-home-ground flex min-h-screen items-center justify-center px-6 py-8">
        <div className="max-w-lg w-full text-center">
          <h1 className="text-display-xl mb-6 text-balance text-gray-900">Page not found</h1>

          <p className="text-body mb-6 max-w-md mx-auto text-pretty text-gray-600">
            The page you're looking for doesn't exist or has moved. Let's get you
            back on track.
          </p>

          <Button variant="long-brand" size="lg" shape="pill" asChild data-testid="button-not-found-home">
            <a href="/">Return Home</a>
          </Button>
        </div>
      </div>
    </>
  );
}
